var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("../assets/icons/Spinner@1x-1.0s-200px-200px.svg"),"alt":"loader gif","width":_vm.size,"height":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }